import * as types from '../types';
import axios from 'axios';
import { IReportDraft } from '../common/defaults';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';

export const saveTypesToStore = (Types) => {
  return {
    type: types.LOAD_ALL_TYPES_INTO_STORE,
    value: Types,
  };
};

export const saveDraftsToStore = (Drafts) => {
  return {
    type: types.SAVE_DRAFT_TO_STORE,
    value: Drafts,
  };
};

const headers = new Headers([
  ['Accept', 'application/json, text/plain, */*'],
  ['Content-Type', 'application/json'],
]);

export const getAllTypes = (requestURL: string) => {
  return async (dispatch) => {
    await Api.get(requestURL)
      .then((res: ApiResponse<any>) => {
        dispatch(saveDraftsToStore(res.data));
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  };
};

export const getAllReportDrafts = (requestURL: string) => {
  return async (dispatch) => {
    await Api.get(requestURL)
      .then((res: ApiResponse<any>) => {
        dispatch(saveDraftsToStore(res.data));
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  };
};

export const getReportDraftById = (requestURL: string, id: number) => {
  return async (dispatch) => {
    await Api.get(requestURL, id)
      .then((res: ApiResponse<any>) => {
        dispatch(saveDraftsToStore(res.data));
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  };
};

export const getFormIoFormId = () => {
  return (dispatch, getState) => {
    const state = getState();
    Api.get(state.Application.backendURL + 'DriverReport/FormIoFormId').then(
      (response: ApiResponse<string>) =>
        dispatch(gotFormIoFormId(response.data))
    );
  };
};

const gotFormIoFormId = (formId: string) => ({
  type: types.GET_FORM_IO_FORM_ID,
  value: formId,
});
